<template>
    <v-app id="searchPtenDeduplicate">
        <!-- header -->
        <headerPtenDeduplicate @actionClick="actionClick" class="mt-16"/>
        <!-- table -->
        <tablePten ref="tablePten" list="deduplicate" @actionClick="actionClick" class="mt-0 px-3" />
        <!-- navBar -->
        <navbarPten menuIndex="0" @actionClick="actionClick" />
    </v-app>
</template>

<script>
    import headerPtenDeduplicate from '@/components/pten/headerPtenDeduplicate.vue';
    import tablePten from '@/components/pten/tablePten.vue';
    import navbarPten from '@/components/pten/navbarPten.vue';
    
    export default {
        components: {
            headerPtenDeduplicate,
            tablePten,
            navbarPten,
        },
        data() {
            return {
            }
        },
        mounted() {
            document.title = "ARES - Deduplicate Leads";
        },
        methods: {
            actionClick(action) {
                switch (action) {
                    case "refresh":
                        this.$refs.tablePten.getPtens();
                        break;
                    default:
                        break;
                }
            },
        }
    };
</script> 
